import { Volume2, VolumeX } from "lucide-react";

const SoundToggle = ({ t, on, onToggle }) => (
  <button
    data-testid="sound-toggle"
    onClick={onToggle}
    aria-label={on ? t.soundOff : t.soundOn}
    aria-pressed={on}
    className={`flex h-10 w-10 items-center justify-center rounded-full border backdrop-blur-xl transition-[background-color,border-color,color] duration-300 ${
      on
        ? "border-amber-500/50 bg-amber-500/15 text-amber-300"
        : "border-white/10 bg-black/40 text-white/60 hover:text-white/90"
    }`}
  >
    {on ? <Volume2 className="h-4 w-4" strokeWidth={1.5} /> : <VolumeX className="h-4 w-4" strokeWidth={1.5} />}
  </button>
);

export default SoundToggle;
